/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:52:59
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title4 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import SelectLogo from '../components/SelectLogo';
import { applyThousands } from '../utils';

class P15 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      tableColumns: [],
      tableList: [],
      chartColorList: [],
    }
  }

  fillColor = (tableColumns) => {
    const border = `none`
    return tableColumns.map((item, index) => {
      return {
        ...item,
        style: {
          ...item.style,
          display: 'none',
          height: 50,
          fontSize: 18,
          textAlign: 'center',
          fontWeight: 'bold',
          color: '#000',
          background: '#fff',
          borderRight: border,
          borderBottom: '1px solid #000',
        },
        colStyle: (_, ii, i) => {
          return {
            display: i === 0 ? 'none' : '',
            height: 50,
            fontSize: 18,
            textAlign: 'center',
            fontWeight: index === 0 ? 'bold' : 'normal',
            color: i === 4 ? 'red' : '#000',
            background: '#fff',
            borderRight: border,
            borderBottom: border,
          }
        },
        render: (val, record, index) => {
          // console.log(val, arg)
          let name = 'KOL内容占';
          if (index === 0) {
            name = '新闻+自媒体内容';
          }
          return (
            <div>
              {name}
              <br/>
              {val}
            </div>
          )
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, tableColumns, tableList, chartColorList } = this.state;
    const width = 1210 / chartList.length;

    return (
      <Stage>
        <Title4 pageNumber="3.6">安踏VS竞品 | KOL占比状况对比</Title4>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>
            安踏内容总条数和KOL内容占比分别排名第四名和第五名，相比竞品表现欠佳
            </div>
            <div contentEditable className={s.des}>
            从KOL所发表的内容条数来看，安踏全年为72,189条，低于李宁和耐克；在同等数量级上进行比较（30万条以上），安踏的KOL发表内容条数占比为23.84%，低于李宁，高于耐克和斐乐。理想状况是品牌在总内容条数、KOL发表内容条数占比两方面均为第一，这说明该品牌既能得到KOL的高度关注，又在普通用户中有较高热度。
            </div>
          </div>


          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              {chartList.map((item, index) => (
                <div
                  key={index}
                  className={s.logoWrapper}
                  style={{
                    left: width * index + width / 2,
                  }}>
                  <SelectLogo iconId={item.id} className={s.selectLogoClassName} imgClassName={s.imgBox} />
                </div>
              ))}
              <Chart isShow options={setChart({
                label: chartTitle,
                list: chartList,
                color: chartColorList
              })} />
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable columns={this.fillColor(tableColumns)} data={applyThousands(tableList)} style={{ boxShadow: 'none' }} />
              </TooltipDrawer>
            </div>
          </div>

        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P15);



// WEBPACK FOOTER //
// src/routes/visualChart/P15/index.js